"use strict";

import angular from "angular";

export class CemTechniqueDialogModel {
  constructor(data) {
    this.updatedCEMTechniqueCEMTechData = angular.copy(
      data.CEMTechniqueCEMTechData
    );

    this.submitted = false;
    this.modalService = null;
    this.scope = null;
    this.localReport = data.Report;
    this.techniqueCode = this.updatedCEMTechniqueCEMTechData.Technique.Code;
    this.cemTags = [
      {
        key: "@Contrast",
        field: "ContrastAgent",
      },
      { key: "@Dosage", field: "Dosage" },
      { key: "@Volume", field: "Volume" },
      { key: "@Vein", field: "Vein" },
      { key: "@Gauge", field: "CatheterGauge" },
      {
        key: "@Complication",
        field: "ComplicationsAndReaction",
      },
      {
        key: "@Reaction",
        field: "ReactionType",
      },
      { key: "@Note", field: "Note" },
      {
        key: "@UDF1",
        field: "U1",
      },
      {
        key: "@UDF2",
        field: "U2",
      },
      {
        key: "@UDF3",
        field: "U3",
      },
      {
        key: "@UDF4",
        field: "U4",
      },
    ];

    this.config = {
      Techniques: data.Techniques,
      ContrastAgents: data.ContrastAgents,
      Veins: data.Veins,
      CatheterGauges: data.CatheterGauges,
      ComplicationsAndReactions: data.ComplicationsAndReactions,
      ReactionTypes: data.ReactionTypes,
      CEMTNoComp: data.NoComplications,
      udfFieldsConfigs: data.UdfFieldsConfigs || [],
      ...this.getFieldLabelsConfigs(data.FieldLabelsConfigs),
    };
  }

  init(modal, scope, modalService) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
    this.parseTechniqueReport();

    this.buildReport();
    this.scope.$watchCollection(
      function () {
        return this.updatedCEMTechniqueCEMTechData;
      }.bind(this),
      function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (!newVal) {
            return;
          }

          if(!newVal.Technique.Code && newVal.Technique){
            this.techniqueCode = newVal.Technique;
          } else {
            this.techniqueCode = newVal.Technique.Code;
          }

          if (!newVal.Technique) {
            this.localReport = "";
          }

          this.buildReport();
        }
      }.bind(this)
    );
  }

  buildReport() {
    const data = this.updatedCEMTechniqueCEMTechData;

    if (!data.Technique) {
      return;
    }

    let report =
      angular.copy(
        this.config.Techniques.find((t) => t.Code === this.techniqueCode).Report
      ) || "";

    let isComplicationTagInReport = false;

    this.cemTags.forEach((tag) => {
      const regex = new RegExp(`${tag.key}\\*?`, "gi");
      const fieldValue = this.getFieldValue(tag.field, data[tag.field]);

      if (tag.field === "ComplicationsAndReaction") {
        const isExist = report.includes(tag.key);
        isComplicationTagInReport = isExist;
      }

      if (
        data[tag.field] &&
        data[tag.field].toString().trim() !== "" &&
        data[tag.field].toString() !== "0.0"
      ) {
        report = report.replace(regex, fieldValue);
      }
    });

    report = this.processComplications(report, isComplicationTagInReport);

    report = report.replace(/@blank/gi, "\n\n");

    report = this.processVFPScripts(report);

    report = this.processBracedPhrases(report);

    this.localReport = report.replaceAll("{", "").replaceAll("}", "");
    return report;
  }

  getFieldValue(fieldName, fieldCode) {
    if (!fieldCode) return "";

    const configListName = fieldName + "s";

    if (configListName && this.config[configListName]) {
      const item = this.config[configListName].find(
        (item) => item.Code === fieldCode
      );
      return item ? item.Desc : fieldCode;
    }

    return fieldCode;
  }

  processComplications(report, isComplicationTagInReport) {
    const data = this.updatedCEMTechniqueCEMTechData;
    const hasReaction = data.ReactionType && data.ReactionType.trim() !== "";
    const hasComplication =
      data.ComplicationsAndReaction &&
      data.ComplicationsAndReaction.trim() !== "";

    if (!hasReaction && !hasComplication && isComplicationTagInReport) {
      const complicationPattern =
        /\{@Blank\s+The patient experienced a\{[^}]*@Reaction[^}]*\}\{[^}]*@Complication[^}]*\}[^}]*\}/gi;
      report = report.replace(complicationPattern, "{@Blank}");

      const noCompPattern = /\{\s*@Nocomplication\s*\}/gi;
      report = report.replace(noCompPattern, this.config.CEMTNoComp || "");
    } else {
      const noCompPattern = /\{\s*@Nocomplication\s*\}/gi;
      report = report.replace(noCompPattern, "");

      const blankPattern = /\{@Blank\s+([^{}]*(\{[^}]*\})+[^}]*)\}/gi;

      report = report.replace(blankPattern, "$1");
    }

    return report;
  }

  processVFPScripts(report) {
    const vfpRegex = /<<([^>]*)>>/g;
    return report.replace(vfpRegex, (match, code) => {
      try {
        return this.evaluateVFPScript(code);
      } catch (error) {
        console.error("Error evaluating VFP script:", error);
        return match;
      }
    });
  }

  evaluateVFPScript(code) {
    return code;
  }

  processBracedPhrases(report) {
    const braceRegex = /\{([^}]*)\}/g;
    return report.replace(braceRegex, (match, phrase) => {
      if (phrase.includes("@")) {
        return "";
      }
      return phrase;
    });
  }

  save() {
    this.submitted = true;

    let allRequiredFilled = true;

    this.cemTags
      .filter((t) => t.required)
      .forEach((t) => {
        if (!this.updatedCEMTechniqueCEMTechData[t.field]) {
          allRequiredFilled = false;
          return false;
        }
      });

    if (!this.updatedCEMTechniqueCEMTechData.Technique) {
      this.modalService.showAlert("Please select a CEM Technique first.");
      return;
    } else if (!allRequiredFilled) {
      this.modalService.showAlert("Please fill up all required fields.");
      return;
    }

    if (!this.updatedCEMTechniqueCEMTechData.Technique) return;
    this.modalInstance.remove();
  }

  async closeWindow() {
    this.cancelled = true;
    this.modalInstance.remove();
  }

  parseTechniqueReport() {
    const report = this.updatedCEMTechniqueCEMTechData.Report || "";
    if (!report.trim()) {
      this.cemTags.forEach((t) => (t.visible = true));
      return;
    }

    this.cemTags.forEach((t) => {
      const udfField = this.config.udfFieldsConfigs.find(
        (ufc) => ufc.FieldName == t.field
      );
      const isUdfField = !!udfField;
      const isUdfFieldEnabled = udfField && udfField.Enabled;

      if (isUdfField && !isUdfFieldEnabled) {
        return;
      } else if (isUdfField) {

        if (udfField.Values) {
          t.values = udfField.Values.split(/\r?\n/)
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
            .map((line) => {
              const [prompt, value] = line.split(",").map((s) => s.trim());
              return {
                prompt: prompt,
                value: value,
              };
            });
          udfField.ValuesList = t.values;
          udfField.Multiple = true;
          t.multiple = true;
        } else {
          t.multiple = false;
          udfField.Multiple = false;
          t.values = [];
        }
      }

      // this goes from report template
      const visibleRegex = new RegExp(t.key, "i");
      t.visible = isUdfField || visibleRegex.test(report);
      const requiredRegex = new RegExp(`${t.key}\\*`, "i");
      t.required = requiredRegex.test(report);
    });
  }

  getFieldLabelsConfigs(fieldLabelsConfigs) {
    const map = {
      popTechnique: "TechniqueLabel",
      popcontrast: "ContrastAgentLabel",
      lblDosage: "DosageLabel",
      lblVolume: "VolumeLabel",
      popVein: "VeinLabel",
      popGauge: "CatheterGaugeLabel",
      popComplication: "ComplicationsAndReactionLabel",
      popReaction: "ReactionTypeLabel",
      lblNotes: "NoteLabel",
    };

    const defaults = {
      TechniqueLabel: "Technique",
      ContrastAgentLabel: "Contrast Agent",
      DosageLabel: "Dosage",
      VolumeLabel: "Volume",
      VeinLabel: "Vein",
      CatheterGaugeLabel: "Catheter Gauge",
      ComplicationsAndReactionLabel: "Complications/Reaction",
      ReactionTypeLabel: "Reaction Type",
      NoteLabel: "Note",
    };

    const result = {};

    for (const [key, labelProp] of Object.entries(map)) {
      result[labelProp] = fieldLabelsConfigs[key] || defaults[labelProp];
    }

    return result;
  }

  isVisible(field) {
    const tag = this.cemTags.find(function (t) {
      return t.field === field;
    });
    return tag ? tag.visible : false;
  }

  isInvalid(field) {
    if (!this.submitted) {
      return false;
    }

    const tag = this.cemTags.find(function (t) {
      return t.field === field;
    });
    const isRequired = tag ? tag.required : false;

    if (!isRequired) {
      return false;
    }

    const value = this.updatedCEMTechniqueCEMTechData[field];
    return (
      !value || value.toString().trim() === "" || value.toString() === "0.0"
    );
  }

  remove() {
    this.cancelled = false;
    this.updatedCEMTechniqueCEMTechData = undefined;
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/cemTechniqueDialogModel.js